import { type SVGProps } from "react";

type DisplayIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

const MediaConsoleIcon = ({ size = 24, ...props }: DisplayIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="27.333 50.807 449.334 390.386"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path d="M391.965 245.807H125.368c-5.523 0-10-4.478-10-10v-165c0-5.522 4.477-10 10-10h266.597c5.523 0 10 4.478 10 10v165c0 5.522-4.477 10-10 10zm-256.597-20h246.597v-145H135.368v145zM480.667 451.193H31.333c-5.523 0-10-4.478-10-10V275.859c0-5.522 4.477-10 10-10h449.333c5.523 0 10 4.478 10 10v165.334c.001 5.523-4.477 10-9.999 10zm-439.334-20h429.333V285.859H41.333v145.334z" />
    <path d="M480.667 451.193H256c-5.523 0-10-4.478-10-10V275.859c0-5.522 4.477-10 10-10h224.667c5.523 0 10 4.478 10 10v165.334c0 5.523-4.478 10-10 10zm-214.667-20h204.667V285.859H266v145.334z" />
    <path d="M278.167 275.08h-39c-5.523 0-10-4.478-10-10v-29.273c0-5.522 4.477-10 10-10h39c5.523 0 10 4.478 10 10v29.273c0 5.523-4.478 10-10 10zm-29-20h19v-9.273h-19v9.273zM218.767 382.476c-5.523 0-10-4.478-10-10v-28c0-5.522 4.477-10 10-10s10 4.478 10 10v28c0 5.522-4.477 10-10 10zM292.767 382.476c-5.523 0-10-4.478-10-10v-28c0-5.522 4.477-10 10-10s10 4.478 10 10v28c0 5.522-4.477 10-10 10z" />
  </svg>
);

export { MediaConsoleIcon };
